import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import CustomerInfo from 'src/components/CustomerInfo';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';


function Summary({
  className, ReceiptNo, readonly, tasks
}) {
  const customer = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
  const [anketOpen, setAnketOpen] = React.useState(parseInt((customer[0] && customer[0].DurumKodu) || 0) === 33);
  if (customer.length === 0) {
    return null;
  }
  return (
    <div>
      <CustomerInfo customer={customer[0]} readonly={readonly} ReceiptNoParam={ReceiptNo} />
    </div>

  );
}

Summary.propTypes = {
  className: PropTypes.string,
  ReceiptNo: PropTypes.string,
  tasks: PropTypes.object
};


export default connect(
  (state) => ({ tasks: state.tasks1 })
)(Summary);
